import '../App.css';
import Loader from '../Loader';
import {useState,useEffect} from 'react'; 
import image from '../Images/leetcode.png'; 
import { PageType } from '../Constants';
import Header from '../Header';
function Leetcode(){
         const [data,setData]=useState(null);  
         const [img,Setimg]=useState(image);  
         useEffect(()=>{
            fetch('https://kontests.net/api/v1/leet_code').then((data)=>data.json()).then((response)=>{  
                   setData(response);       
                   console.log(response);
            });
         },[]);
         useEffect(()=>{
          window.scrollTo(0,0);
      },[]);
    return (
        <>
        {data==null ? <Loader/> : null}
        {data != null && <>
        <Header Pagetype={PageType.CONTEST_PAGE} Title={"LeetCode Contests"}/>
        {data.map((Data)=>
        <div className="card"> 
             <div className="img-div">
                  <img className="img" src={img} title="Leetcode"></img>  
             </div>
             <div className="divbody">   
                  <p className="card-title">{Data.name}</p>
                  <a href={Data.url} target="_blank"><button className="btn">Enter</button></a>  
             </div>
        </div> 
        )}
        </>
      }
     </>  
    );
}
export default Leetcode;  